import React, {useEffect, useRef, useState} from 'react';
import DatePicker, {
  registerLocale,
} from 'react-datepicker';
import {
  parseISO,
} from 'date-fns';
import './styles.scss';
import 'react-datepicker/dist/react-datepicker.css';
import {Row} from '../../layout';
import {createClassName} from '../../../util/utility';
import Icon from '../../icon';
import moment from 'moment';
import {Icons} from '../../../util/icons';
import {compose} from 'redux';
import {connect} from 'react-redux';
import colors from '../../../util/colors';
import pt from 'date-fns/locale/pt'; // the locale you want

function AppDateCustomInput({
  onChange,
  placeholder,
  value,
  className,
  buStyles,
  language,
  error,
  noCalendar,
  defaultColor = false,
  minDate,
  maxDate,
  isLoading,
  getAvailableSlotsByTime,
  doctorAvailableSlots,
  doctorAvailableSlotsFromToday,
  ...rest
}) {
  const dateInput = useRef(null);

  registerLocale('pt', pt);
  const classes = createClassName('datepicker-input-container', className);
  const [open, setOpen] = useState(false);

  function formatDate(date) {
    var day;
    var month;
    var year;

    var newDate = new Date();

    if (date !== undefined) {
      if (date?.length === 10) {
        day = date.toString().substring(0, 2);
        month = date.toString().substring(2, 4);
        year = date.toString().substring(4, 8);
        newDate.setDate(day);
        newDate.setMonth(month - 1);
        newDate.setFullYear(year);
        if (!isNaN(newDate?.getDate()) && !isNaN(newDate?.getTime()))
          return newDate;
      }
    }
  }

  // Custom filter function to disable specific dates
  const filterDates = (date) => {
    // Disable dates that are not included in includedDates array
    return doctorAvailableSlotsFromToday.some((slot) =>
      moment(date).isSame(moment(slot, 'DD-MM-YYYY'), 'day')
    );
  };

  const autoFormatDate = (e) => {
    var dateInput = document.getElementsByClassName('app-date-input')[0];

    dateInput.maxLength = 10;

    if (dateInput && dateInput.value) {
      // Backspace detetion...
      dateInput.onkeydown = function (e) {
        if (e.key === 'Backspace')
          if (dateInput.value.length === 3 || dateInput.value.length === 6)
            // ... because, in this if case, it must delete the "/" character, plus the last number
            dateInput.value = dateInput.value.slice(0, -1);
      };

      // everytime the string reaches length === 2 or 5, a "/" char is added
      if (dateInput.value.length === 2) {
        dateInput.value = dateInput.value + '/';
      }
      if (dateInput.value.length === 5) {
        dateInput.value = dateInput.value + '/';
      }
    }
  };

  const openCalendar = () => {
    setOpen(true);
  };

  const renderEmptyDays = (day, date) => {
    return <></>;
  };

  useEffect(() => {
    setOpen(false);
  }, [value]);

  return (
    <label className="date-input-wrapper" onClick={(e) => e.preventDefault()}>
      <Row className={classes}>
        <DatePicker
          onClickOutside={() => {
            setOpen(false);
          }}
          onInputClick={() => {
            setOpen(true);
          }}
          ref={dateInput}
          open={open}
          placeholderText={placeholder}
          dropdownMode="scroll"
          yearDropdownItemNumber={5}
          maxDate={maxDate}
          renderDayContents={isLoading ? renderEmptyDays : undefined}
          filterDate={filterDates} // Custom filter function
          locale="pt"
          renderCustomHeader={({
            monthDate,
            customHeaderCount,
            decreaseMonth,
            increaseMonth,
          }) => {
            const disablePreviousMonthArrow = () => {
              return moment(monthDate).isSameOrBefore(
                moment(minDate).endOf('month')
              );
            };
            return (
              <div>
                {!disablePreviousMonthArrow() && (
                  <button
                    aria-label="Previous Month"
                    className={
                      'react-datepicker__navigation react-datepicker__navigation--previous'
                    }
                    style={
                      customHeaderCount === 1
                        ? {visibility: 'hidden'}
                        : undefined
                    }
                    onClick={() => {
                      decreaseMonth();
                      decreaseMonth();
                    }}>
                    <span
                      className={
                        'react-datepicker__navigation-icon react-datepicker__navigation-icon--previous'
                      }>
                      {'<'}
                    </span>
                  </button>
                )}
                <span className="react-datepicker__current-month">
                  {monthDate.toLocaleString(language, {
                    month: 'long',
                    year: 'numeric',
                  })}
                </span>
                <button
                  aria-label="Next Month"
                  className={
                    'react-datepicker__navigation react-datepicker__navigation--next'
                  }
                  style={
                    customHeaderCount === 0 ? {visibility: 'hidden'} : undefined
                  }
                  onClick={() => {
                    increaseMonth();
                    increaseMonth();
                  }}>
                  <span
                    className={
                      'react-datepicker__navigation-icon react-datepicker__navigation-icon--next'
                    }>
                    {'>'}
                  </span>
                </button>
              </div>
            );
          }}
          // onMonthChange={async (month) => {
          //   const monthNumber = month.getMonth(); // Adding 1 because getMonth() returns a zero-based index
          //   const monthStart = moment()
          //     .clone()
          //     .month(monthNumber)
          //     .startOf('month')
          //     .format('YYYY-MM-DD');
          //   const monthEnd = moment()
          //     .clone()
          //     .month(monthNumber)
          //     .add(2, 'months')
          //     .startOf('month')
          //     .subtract(1, 'day')
          //     .endOf('month')
          //     .format('YYYY-MM-DD');
          //   setCalendarLoading(true);
          //   await getAvailableSlotsByTime(
          //     '00:00',
          //     monthStart,
          //     '00:00',
          //     monthEnd
          //   );
          //   setCalendarLoading(false);
          // }}
          dateFormat="dd/MM/yyyy"
          onChange={(date) => {
            onChange(date);
          }}
          onChangeRaw={(date) => {
            onChange(formatDate(date.target.value));
            autoFormatDate(date);
          }}
          className="app-text-input app-date-input"
          value={value}
          calendarClassName={
            isLoading ? 'custom-calendar-loading' : 'custom-calendar'
          }
          minDate={parseISO(minDate)}
          //includeDates={doctorAvailableSlots}
          monthsShown={2}
          {...rest}
        />
        {error && (
          <Icon
            width="24"
            height="24"
            className="app-form-field-error"
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
          />
        )}
        {!noCalendar && (
          <Icon
            color={
              defaultColor ? colors.blue : buStyles?.primary || colors.blue
            }
            className="calendar-icon"
            name={Icons.CALENDAR}
            width="14"
            height="14"
            onClick={openCalendar}
            changeViewbox={true}
          />
        )}
      </Row>
    </label>
  );
}

const mapStateToProps = ({globalStyles, language}) => ({
  buStyles: globalStyles.value,
  language: language.value,
});

export default compose(connect(mapStateToProps)(AppDateCustomInput));
